<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @new-item="newItem"
                            @delete-items="deleteItems"
                            @export="exportItems"
                            ref="gofixTable">
                            <template slot="gofix_table:actions" slot-scope="row" v-if="row.item.status != 'New'">
                                <b-form-checkbox disabled></b-form-checkbox>
                            </template>
                            <template slot="gofix_table:date" slot-scope="row">
                                {{row.item.date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:qr_code" slot-scope="row">
                                <b-button
                                    v-if="['New'].includes(row.item.status)"
                                    @click="showQRCode(row.item)" 
                                    class="goFixPrintButton" 
                                    title="Print">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-qr-code" viewBox="0 0 16 16">
                                            <path d="M2 2h2v2H2z"/>
                                            <path d="M6 0v6H0V0zM5 1H1v4h4zM4 12H2v2h2z"/>
                                            <path d="M6 10v6H0v-6zm-5 1v4h4v-4zm11-9h2v2h-2z"/>
                                            <path d="M10 0v6h6V0zm5 1v4h-4V1zM8 1V0h1v2H8v2H7V1zm0 5V4h1v2zM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8zm0 0v1H2V8H1v1H0V7h3v1zm10 1h-1V7h1zm-1 0h-1v2h2v-1h-1zm-4 0h2v1h-1v1h-1zm2 3v-1h-1v1h-1v1H9v1h3v-2zm0 0h3v1h-2v1h-1zm-4-1v1h1v-2H7v1z"/>
                                            <path d="M7 12h1v3h4v1H7zm9 2v2h-3v-1h2v-1z"/>
                                        </svg>
                                </b-button>
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            title="Add A Briefing Record" 
            hide-footer 
            :centered="true" 
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <dropdown-projects
                            required
                            show-icon-required
                            @setDefaultValue="setDefaultProject"
                            v-model="modals.add.data.project">
                        </dropdown-projects>
                        <gofix-form-input-date
                            :minDate="new Date()"
                            required
                            show-icon-required
                            v-model="modals.add.data.date"
                            label="Date">
                        </gofix-form-input-date>
                        <gofix-form-input 
                            label="Venue" 
                            v-model="modals.add.data.venue">
                        </gofix-form-input>
                        <gofix-form-dropdown 
                            label="Topics" 
                            vLabel="reference_value_text"
                            required
                            show-icon-required
                            multiple
                            v-model="modals.add.data.topics" 
                            :options="modals.add.options.topics">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>

        <b-modal :no-close-on-backdrop="true"
            id="modal-Create"
            title="Register for Brifing" hide-footer :centered="true"
            v-model="modals.qr_code.open">
            <div class="preview">
                <gofix-text-field class="mb-3" label="URL" inputStyle>
                    {{localHref + "/#/briefing-register?briefing_id=" + modals.qr_code.data.id}}
                </gofix-text-field>
                <gofix-text-field label="QR Code" inputStyle>
                    <div class="text-center">
                        <qrcode-vue :value="`${localHref}/#/briefing-register?briefing_id=${modals.qr_code.data.id}`" :size="130" level="L"></qrcode-vue>
                        <gofix-button label="Download Hi-res QR Image" @click="downloadQRCode" outline></gofix-button>
                    </div>
                </gofix-text-field>
            </div>
        </b-modal>
    </div>
</template>

<script>
import moment from 'moment';
import { filters } from '@/_filterVar.js'
import QrcodeVue from 'qrcode.vue'
import DropdownProjects from '../elements/DropdownProjects.vue'
export default {
    components: {
        QrcodeVue,
        DropdownProjects
    },
    name: 'safety-induction-training-listing',
    data() {
        let filter = JSON.parse(JSON.stringify(filters['safety_induction_training']));
        return {
            localHref : window.location.origin,
            tableConfig:{
                name: 'safety-induction-training-listing',
                controls:{
                    create: this.$checkRole(this.$accessModule.safety_induction_training, 'create'),
                    delete: this.$checkRole(this.$accessModule.safety_induction_training, 'delete')
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "created_at",
                sortDirection: "desc",
                dataSelect: {
                    status: {
                        value: [
                            {value: 'New', text: 'New'},
                            {value: 'Briefing Completed', text: 'Briefing Completed'},
                            {value: 'Training Accepted', text: 'Training Accepted'},
                            {value: 'Started', text: 'Started'},
                            {value: 'Training Completed', text: 'Training Completed'},
                            {value: 'Rejected', text: 'Rejected'},
                            {value: 'Expired', text: 'Expired'},
                        ],
                        value_field: 'value',
                        text_field: 'text'
                    }
                },
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        project: null,
                        topics: null,
                        venue: null,
                        date: null
                    },
                    options: {
                        scontracts: [],
                        topics: [],
                    }
                },
                qr_code: {
                    open: false,
                    data: {
                        id: null
                    }
                }
            },
            timer: {
                scontracts: null,
                save: null
            },
        }
    },
    computed: {
        // Add computed properties here
    },
    watch: {
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("SafetyAppController/getSafetyInductionTrainingItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of users", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },  
        clickToRowItem(item) {
           this.$router.push(`/v2/safety-induction-training/${item.id}`)
        },
        newItem() {
            // if(!this.ClientContractID || !this.ClientContractID.id) {
            //     return this.$alertNotification("Please select a contract before create briefing record.", "warning");
            // }
            this.getTopics();
            this.modals.add.data = {
                project: null,
                topics: null,
                venue: null,
                date: null
            };
            this.modals.add.open = true;
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deleteSafetyInductionTrainingItem", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'safe_induction_training_briefing'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems() {
            // Handle exporting items
            // Implement export logic (e.g., to CSV, PDF, etc.)
        },

        getTopics(){
            let filter = {reference_type: "Safety Induction Training Topics"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.modals.add.options.topics = response.items;
                })
        },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {

                const validate_fields = [
                    { key: 'project', name: 'Project'},
                    { key: 'date', name: 'Date'},
                    { key: 'venue', name: 'Venue'},
                    { key: 'topics', name: 'Topics'},
                ]

                const is_validate = this.$validationData(validate_fields, this.modals.add.data)
                if(is_validate) return

                if(this.modals.add.loading) return;
                this.modals.add.loading = true;

                let objeClone = {
                    client_contract_id: this.modals.add.data.project.client_contract_id,
                    project_id: this.modals.add.data.project.id,
                    topics: this.modals.add.data.topics,
                    venue: this.modals.add.data.venue,
                    date: moment(this.modals.add.data.date).format('YYYY-MM-DD'),
                };
                
                this.$store.dispatch("SafetyAppController/createSafetyInductionTrainingItem", objeClone)
                .then(async response => {
                    this.modals.add.loading = false;
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.modals.add.open = false;
                    await this.$router.push(`/v2/safety-induction-training/${response.id}`)
                    await this.$alertNotification(this.$notificationV2('adding', 'safe_induction_training_briefing'), "success");
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })

            }, 200);
        },
        showQRCode(item) {
            this.modals.qr_code.data.id = item.id;
            this.modals.qr_code.open = true;
        },
        downloadQRCode() {
            this.$store.dispatch(`SafetyAppController/dowloadQRCodeSafetyInductionTraining`, this.modals.qr_code.data.id)
                .then(response => {
                    const link = document.createElement('a');
                    link.href = response;
                    link.setAttribute('download', `QRCode_Briefing_${this.modals.qr_code.data.id}.png`);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(error => {
                    console.log(error);
                })
        },
        setDefaultProject(val) {
            this.modals.add.data.project = val
        },
    },
    created() {
        // Component lifecycle hook for initialization
    }
}
</script>